import styled from '@emotion/styled';
import type { Prismic } from '@landsbankinn/prismic';
import { device, mobileGutterMargin } from '@landsbankinn/ui';
import React from 'react';
import { Img } from '../img/Img';
import { PhoneAuthInput } from './PhoneAuthInput';

interface IProps {
  title: string;
  description: string;
  image?: Prismic.Image;
  login: (phoneNumer: string) => void;
  loading: boolean;
  error?: boolean;
}

const tempImage = {
  alt: 'alt texti',
  ar_1_1: {
    alt: null,
    copyright: null,
    dimensions: { width: 1920, height: 1920 },
    url: 'https://images.prismic.io/landsbankinn/94982f1c-642d-4394-a6f4-0379bb6b55d4_Mynd.jpg?auto=compress,format&rect=420,0,1080,1080&w=1920&h=1920',
  },
  ar_4_3: {
    alt: null,
    copyright: null,
    dimensions: { width: 1920, height: 1440 },
    url: 'https://images.prismic.io/landsbankinn/94982f1c-642d-4394-a6f4-0379bb6b55d4_Mynd.jpg?auto=compress,format&rect=240,0,1440,1080&w=1920&h=1440',
  },
  ar_16_9: {
    alt: null,
    copyright: null,
    dimensions: { width: 1920, height: 1080 },
    url: 'https://images.prismic.io/landsbankinn/94982f1c-642d-4394-a6f4-0379bb6b55d4_Mynd.jpg?auto=compress,format&rect=0,0,1920,1080&w=1920&h=1080',
  },
  copyright: null,
  dimensions: { width: 1920, height: 1080 },
  url: 'https://images.prismic.io/landsbankinn/94982f1c-642d-4394-a6f4-0379bb6b55d4_Mynd.jpg?auto=compress,format',
};

export const Host = styled.div`
  display: block;
  position: relative;
  width: auto;
  margin-left: ${(props) => `-${props.theme.containerGutter}px`};
  margin-right: ${(props) => `-${props.theme.containerGutter}px`};
  background-color: ${(props) => props.theme.shades.primary2};
  display: flex;

  flex-direction: column-reverse;
  max-width: 1179px;
  min-height: 581px;
  -webkit-user-select: none;
  -webkit-user-drag: none;
  -webkit-app-region: no-drag;
  padding-bottom: 40px;
  cursor: pointer;
  user-select: text;

  ${mobileGutterMargin}

  @media ${device.desktop} {
    flex-direction: row;
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 30px;
    padding-bottom: 0px;
  }

  &:hover img {
    transform: scale(1.025);
  }
`;

const Body = styled.div`
  padding-top: 72px;
  padding-left: 20px;
  padding-right: 20px;
  @media screen and (max-width: 720px) {
    width: 100%;
  }
  display: flex;
  flex-direction: column;
  @media ${device.desktop} {
    width: 50%;
    padding-left: 100px;
    padding-right: 120px;
  }
`;

const Image = styled(Img)`
  @media ${device.desktop} {
    width: 50%;
  }
  @media screen and (max-width: 720px) {
    width: 100%;
  }
`;

export function PhoneAuthentication({
  title,
  description,
  image,
  login,
  loading,
  error,
}: IProps) {
  return (
    <Host>
      <Body>
        <PhoneAuthInput
          title={title}
          description={description}
          login={login}
          loading={loading}
          error={error}
        />
      </Body>
      <Image
        alt="Rafræn auðkenning"
        src={image ? image : tempImage}
        aspectRatio={4 / 3}
      />
    </Host>
  );
}
